import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import { ReactNode } from "react";
import { Card } from "shared/components/Card";

export const DashboardBanner = ({
  icon,
  title,
  body,
  action
}: {
  icon: IconSvgElement;
  title: string;
  body: string;
  action?: ReactNode;
}) => {
  return (
    <Card className="h-[84px] px-6 flex gap-6 items-center animate-appear">
      <HugeiconsIcon
        size={50}
        strokeWidth={1}
        className="text-content-1000"
        icon={icon}
      />

      <div>
        <h2 className="text-base text-content-1000 font-bold mb-1">{title}</h2>
        <p className="text-sm font-medium text-content-300">{body}</p>
      </div>

      {action ? <div className="ml-auto">{action}</div> : null}
    </Card>
  );
};
